import { Injectable } from '@angular/core';
import { Platform, ModalController } from '@ionic/angular';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { RestService } from './rest.service';
import { KeyboardOnScreenComponent } from '../shared/keyboard-on-screen/keyboard-on-screen.page';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Observable, timeout, catchError, of } from 'rxjs';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { PROBE_TIMEOUT_MS, probeSaysOnline } from './connectivity-probe.util';

@Injectable({
    providedIn: 'root' 
})
  
export class ToolsService {
    showHeader: boolean = false;
    showLogo: boolean = false;
    surveyMode: boolean = false;
    reelsPreviewMode: boolean = false;
    reelsMode: boolean = false;
    currentGalery: any;
    arrayModals: any = [];
    timer: any;
    isOffline: boolean = false;
    isChechingInternet: boolean = false;
    baseUrl: any;
    appId: any;
    isDistributor: boolean = false;
    isApp: boolean = false;
    
    constructor(
        public platform: Platform, 
        public translate: TranslateService, 
        private rest: RestService, 
        private modalCtrl: ModalController,
        public idle: Idle,
        private http: HttpClient
    ) {}


  //--------------------------------------------------------------------------------------------------------------------------------------------------
  //------------------------------------------------------------ REDIRECCION  ------------------------------------------------------------------------

    checkAppDataStarted(){
      console.warn("CHECKING IF APP STARTED...", this.rest.device)
      if (!this.rest?.responseData){
        const macFromLocalStorage = localStorage.getItem('mac');
        const baseUrl = localStorage.getItem('baseUrl');
        if (!macFromLocalStorage || !baseUrl) return;
        const appUrl = `${JSON.parse(baseUrl)}/?mac=${JSON.parse(macFromLocalStorage)}`;
        window.location.href = appUrl
      } 

    }

    //--------------------------------------------------------------------------------------------------------------------------------------------------
    //------------------------------------------------------------ TEMP LOCAL STORAGE ------------------------------------------------------------------

    saveSessionData(){
        localStorage.removeItem("myCustomRoute");
        localStorage.setItem('myCustomRoute', JSON.stringify(this.rest.myCustomRoute));
    }

    //--------------------------------------------------------------------------------------------------------------------------------------------------
    //--------------------------------------------------------------- ERROR IMAGEN ----------------------------------------------------------------------
    onImageError(e){ e.target.src = "/assets/imgs/imageDefault.png"; }
    onImgOfferError(e){ e.target.style.objectFit = "contain"; e.target.src = "/assets/imgs/offerDefault.webp"; }
    //--------------------------------------------------------------------------------------------------------------------------------------------------
    //-------------------------------------------------------------- CHECK URL LANG --------------------------------------------------------------------    
    waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
    }

    animateCSS = (element, animation, prefix = 'animate__') =>
    new Promise((resolve, reject) => {
        const animationName = `${prefix}${animation}`;
        const node = element;
        if (node){
            node.classList.add(`${prefix}animated`, animationName);
            function handleAnimationEnd(event) {
                event.stopPropagation();
                node.classList.remove(`${prefix}animated`, animationName);
                resolve('Animation ended');
            }
            node.addEventListener('animationend', handleAnimationEnd, {once: true});
        }
    });

    polylineDecode(str, precision) {
        var index = 0, lat = 0, lng = 0, coordinates = [], shift = 0, result = 0, byte = null,
          latitude_change, longitude_change, factor = Math.pow(10, precision || 6);
        while (index < str.length) {
          byte = null;
          shift = 0;
          result = 0;
          do {
              byte = str.charCodeAt(index++) - 63;
              result |= (byte & 0x1f) << shift;
              shift += 5;
          } while (byte >= 0x20);
          latitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));
          shift = result = 0;
          do {
              byte = str.charCodeAt(index++) - 63;
              result |= (byte & 0x1f) << shift;
              shift += 5;
          } while (byte >= 0x20);
          longitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));
          lat += latitude_change;
          lng += longitude_change;
          coordinates.push({lat:lat / factor, lng:lng / factor});
        }
        return coordinates;
    };

    async openKeyBoard(value, google = false, title = ''){
        const modal = await this.modalCtrl.create({
            component: KeyboardOnScreenComponent,
            cssClass: 'keyboardModal',
            componentProps: { input: value, google: google, title: title }
          });
          this.arrayModals = [...this.arrayModals, modal]
          await modal.present();
          const { data } = await modal.onDidDismiss();
          return data;
    }

    getIcon(color, title = null){
      let svgData = 
          `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 36 50" style="enable-background:new 0 0 36 50;" xml:space="preserve">
              <path style="fill: ${color}; stroke: #1C4963; stroke-width: 2;" d="M18,47l-0.7,0.7l0.7,0.7l0.7-0.7L18,47z M18,47c0.7,0.7,0.7,0.7,0.7,0.7l0,0l0,0l0,0l0,0c0,0,0.1-0.1,0.1-0.1
                c0.1-0.1,0.3-0.3,0.5-0.5c0.4-0.5,1.1-1.1,1.8-2c1.5-1.7,3.5-4.1,5.5-6.9c2-2.8,4-6,5.5-9.3c1.5-3.3,2.6-6.7,2.6-9.9
                C34.8,9.1,27.3,1,18,1C8.7,1,1.2,9.1,1.2,18.9c0,3.2,1,6.7,2.6,9.9c1.5,3.3,3.5,6.5,5.5,9.3c2,2.8,4,5.2,5.5,6.9
                c0.7,0.9,1.4,1.5,1.8,2c0.2,0.2,0.4,0.4,0.5,0.5c0.1,0.1,0.1,0.1,0.1,0.1l0,0l0,0l0,0l0,0C17.3,47.7,17.3,47.7,18,47z"/>
            </svg>`;
      if (title){
          svgData = 
              `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 36 50" style="enable-background:new 0 0 36 50;" xml:space="preserve">
                <path style="fill: ${color}; stroke: #1C4963; stroke-width: 2;" d="M18,47l-0.7,0.7l0.7,0.7l0.7-0.7L18,47z M18,47c0.7,0.7,0.7,0.7,0.7,0.7l0,0l0,0l0,0l0,0c0,0,0.1-0.1,0.1-0.1
                  c0.1-0.1,0.3-0.3,0.5-0.5c0.4-0.5,1.1-1.1,1.8-2c1.5-1.7,3.5-4.1,5.5-6.9c2-2.8,4-6,5.5-9.3c1.5-3.3,2.6-6.7,2.6-9.9
                  C34.8,9.1,27.3,1,18,1C8.7,1,1.2,9.1,1.2,18.9c0,3.2,1,6.7,2.6,9.9c1.5,3.3,3.5,6.5,5.5,9.3c2,2.8,4,5.2,5.5,6.9
                  c0.7,0.9,1.4,1.5,1.8,2c0.2,0.2,0.4,0.4,0.5,0.5c0.1,0.1,0.1,0.1,0.1,0.1l0,0l0,0l0,0l0,0C17.3,47.7,17.3,47.7,18,47z"/>
                <ellipse style="fill: ${color}; stroke: #FFFFFF; stroke-width: 2;" cx="18" cy="18.6" rx="12.3" ry="12.6"/>
                <text transform="matrix(1 0 0 1 15 24.5)" style="fill: #FFFFFF; font-family:'Arial'; font-size:19px; text-align: center;">${title}</text>
              </svg>`;
        }
      return 'data:image/svg+xml;base64,' + btoa(svgData);
    }

    sortPointsPerDistance(items, location){
        const $this = this;
        const hasLocation = location != null
          && !isNaN(parseFloat(location.latitude)) && !isNaN(parseFloat(location.longitude));
        let interestPoints = items?.map(function(item) {
          if (item.type == 'point' || item.type == 'event'){
            item.distance = $this.getDistanciaMetros(parseFloat(location.latitude), parseFloat(location.longitude), parseFloat(item.latitude), parseFloat(item.longitude));
            item.distanceM = item.distance >= 1000 ? (item.distance/1000).toFixed(2)+ " Km's" : item.distance.toFixed(0) + " M's";
          }
          return item;
        });
        // Ordena por cercanía al kiosko (items sin distancia válida al final).
        // Sin coordenadas del dispositivo, se respeta el orden del API.
        if (hasLocation) {
          interestPoints = interestPoints?.sort((a, b) => $this.distanceOrInfinity(a) - $this.distanceOrInfinity(b));
        }
        return interestPoints;
    }

    // Distancia usable para ordenar; NaN/null/undefined -> Infinity (al final).
    distanceOrInfinity(item): number {
        return (item?.distance == null || isNaN(item.distance)) ? Infinity : item.distance;
    }

    //Funcion Auxiliar que calcula la distacia entre dos coordenadas (longitud, latitud)
    getDistanciaMetros(lat1: any, lon1: any, lat2: any, lon2: any): any {
        const rad = function(x) {return x*Math.PI/180;}
        var R = 6378.137; 
        var dLat = rad( lat2 - lat1 );
        var dLong = rad( lon2 - lon1 );
        var a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.cos(rad(lat1)) * 
        Math.cos(rad(lat2)) * Math.sin(dLong/2) * Math.sin(dLong/2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
        var d = R * c * 1000;
        return d ; 
    }

    setCorporiveColors(){
        const root = document.querySelector(':root') as HTMLElement;
        root.style.setProperty('--main-color', this.rest?.device?.style?.colorCorp1 || '#00ABAF');
        root.style.setProperty('--main-color-alpha', `${this.rest?.device?.style?.colorCorp1}BB` || '#00ABAFBB');
        root.style.setProperty('--main-color-strong', this.rest?.device?.style?.colorCorp2 || '#08515D');
        root.style.setProperty('--header-color', this.rest?.device?.style?.headerColor || '#00ABAF');
        root.style.setProperty('--compl-color', this.rest?.device?.style?.corpCompl || '#08515D');
        root.style.setProperty('--background-color', this.rest?.device?.style?.backgroundColor || '#FFF');
    }

    changeLanguage(lang){
        moment.locale(lang);
        this.translate.setDefaultLang(lang);
        this.translate.use(lang);
    }

  //---------------------------------------------------------------------------------------------------------------------------------------------------
  //------------------------------------------------------ESTILOS BARRA DESPLAZAMIENTO ----------------------------------------------------------------
  styleScrollbars(elmt: any) {
    const stylesheet = `
    ::-webkit-scrollbar {
      width: 0.7vmax !important;
    }
    
    ::-webkit-scrollbar-track {
      background: ${this.rest?.device?.style?.colorCorp1 || '#00ABAF'} !important; 
      --background: ${this.rest?.device?.style?.colorCorp1 || '#00ABAF'} !important; 
    }
      
    ::-webkit-scrollbar-thumb {
      background: ${this.rest?.device?.style?.colorCorp2} !important;
      --background: ${this.rest?.device?.style?.colorCorp1 || '#00ABAF'} !important; 
    }
    
    ::-webkit-scrollbar-thumb:hover {
      background: ${this.rest?.device?.style?.colorCorp2} !important;
      --background: ${this.rest?.device?.style?.colorCorp1 || '#00ABAF'} !important; 
    }

    @media only screen and (max-width: 600px) { 
      ::-webkit-scrollbar {
        display: none;
      }
    }
    `;
    const styleElmt = elmt.shadowRoot.querySelector('style');
    if (styleElmt) {
      styleElmt.append(stylesheet);
    } else {
      const barStyle = document.createElement('style');
      barStyle.append(stylesheet);
      elmt.shadowRoot.appendChild(barStyle);
    }
  }

  closeAllModals(){
    this.arrayModals?.forEach(modal => {modal?.dismiss()});
    this.arrayModals = [];
  }

  getLocation() {
    return new Observable((observer) => {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => observer.next(position.coords),
          (error) => observer.error(error),
          { enableHighAccuracy: true }
        );
      } else {
        observer.error('La geolocalización no está disponible en este navegador.');
      }
    });
  }

  getTransparencyInfo(imgUrl: string): Observable<any> {
    return new Observable(observer => {
      const img = new Image();
      img.crossOrigin = 'anonymous'; // Ensure cross-origin is enabled
  
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
  
        canvas.width = img.width;
        canvas.height = img.height;
  
        context.drawImage(img, 0, 0, img.width, img.height);
  
        const imageData = context.getImageData(0, 0, img.width, img.height);
        const pixelData = imageData.data;
  
        const visited = new Set<string>(); // Track visited pixels
        let minX = img.width, minY = img.height, maxX = 0, maxY = 0;
  
        const floodFill = (x: number, y: number) => {
          const stack = [[x, y]];
  
          while (stack.length) {
            const [cx, cy] = stack.pop()!;
            const key = `${cx},${cy}`;
  
            if (visited.has(key)) continue;
            visited.add(key);
  
            const index = (cy * img.width + cx) * 4;
            const alpha = pixelData[index + 3];
  
            if (alpha !== 0) continue; // Skip non-transparent pixels
  
            // Update bounding box
            if (cx < minX) minX = cx;
            if (cy < minY) minY = cy;
            if (cx > maxX) maxX = cx;
            if (cy > maxY) maxY = cy;
  
            // Add neighbors to the stack
            if (cx > 0) stack.push([cx - 1, cy]); // Left
            if (cy > 0) stack.push([cx, cy - 1]); // Top
            if (cx < img.width - 1) stack.push([cx + 1, cy]); // Right
            if (cy < img.height - 1) stack.push([cx, cy + 1]); // Bottom
          }
        };
  
        // Start flood-fill on all transparent pixels
        for (let y = 0; y < img.height; y++) {
          for (let x = 0; x < img.width; x++) {
            const key = `${x},${y}`;
            const index = (y * img.width + x) * 4;
            const alpha = pixelData[index + 3];
  
            if (alpha === 0 && !visited.has(key)) {
              floodFill(x, y);
            }
          }
        }
  
        // Calculate the dimensions of the bounding box
        const width = maxX - minX;
        const height = maxY - minY;
  
        const result = {
          hasTransparency: minX < img.width,
          boundingBox: {
            minX: minX,
            minY: minY,
            maxX: maxX,
            maxY: maxY,
            width: width,
            height: height
          }
        };
  
        observer.next(result);
        observer.complete();
      };
  
      img.src = imgUrl; // Assign the image URL
    });
  }

  calculateFromTotemResolution(value: number){
    let totemWidth = window.innerWidth
    switch(totemWidth){
      case totemWidth = 2160:
        return this.calculateResolution(value).divide(2)
      case totemWidth = 720:
        return this.calculateResolution(value).multiply(1.5)
      default: 
        return this.calculateResolution(value).multiply(1)
    }
  }

  calculateResolution(value: number){
    
    return {
      divide: function(divisor: number) {
        return value / divisor;
      },
      multiply: function(multiplier: number) {
        return value * multiplier;
      }
    };
  }

  //OSRM URL POR DEFECTO PARA COMPROBAR SI HAY ACCESO A OPCIONES QUE REQUIERAN INTERNET
  //No recibe URL a proposito: la sonda pide siempre el recurso fijo y diminuto de
  //`connectivityProbeUrl`. Con el tope de PROBE_TIMEOUT_MS, pedir el contenido que el
  //visitante abre mide el tamano del fichero y no la red (HRS-3148).
  checkInternetStatus(): Promise<boolean> {
    this.isChechingInternet = true
    return new Promise<boolean>((resolve) => {
        this.http.get(environment.connectivityProbeUrl)
            .pipe(
                timeout(PROBE_TIMEOUT_MS), 
                catchError(error => {
                  if (probeSaysOnline(error)){
                    resolve(true)
                    return of(true)
                  }
                  resolve(false)
                  return of(false)
                })
            )
            .subscribe({
                next: () => resolve(true), 
                error: (e) => {console.error(e); resolve(false)},
                complete: () => this.isChechingInternet = false
            });
    });
  }

  replaceExperimentalUrls(response){
    response.data.recommendedRoutes = this.mapRoute(response?.data?.recommendedRoutes);
    response.data.events = response.data.events?.map((event: any) => {
      if (event.tags !== null && typeof event.tags === "object") {
        event.tags = Object.values(event.tags)?.flat();
        return event;
      }
    })

    response.data.interestPoints = response.data.interestPoints?.map((point: any) => {
      if (point.tags !== null && typeof point.tags === "object") {
        point.tags = Object.values(point.tags)?.flat();
        return point;
      }
    })
  }

  mapRoute(recommendedRoutes){
    try{
      return recommendedRoutes.map(e => {
        const data = e.data?.filter(data => {
          const points = this.mapRouteStructure(data.route);
          if (points?.length === 0) 
            return false;
  
          const oldStructure = points.filter(point => !point.isRefactorRoute && point.newDesign);
          const newStructure = points.filter(point => point.isRefactorRoute && point.newDesign)?.map(point => ({ ...point, points: point.points.map(e => ({ ...e, start: moment(e.start, 'HH:mm').hour(), end: moment(e.end, 'HH:mm').hour() })) }))
          const mergedStruc = [...oldStructure, ...newStructure];
          data.points = JSON.stringify(mergedStruc);
          return true;
        })
        return {...e, data}
      });
    }catch(e){
      return [];
    }

  }

  mapRouteStructure(json){
    try{
      const parsed = JSON.parse(json);
      const modify = parsed.map(e => e.points.some(point => ((typeof point.end === 'string' && point.end.includes(':30')) || (typeof point.start === 'string' && point.start.includes(':30')))) ? null : e)?.filter(e => e);
      return modify;
    }catch(e){
      return [];
    }
  }
}